'use strict';

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    Loading = require('components/Commons/Loading/Loading'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    Authentication = require('services/Security').Authentication,
    InventoryStore = require('stores/InventoryStore'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    get = require('lodash/object').get,
    { orderBy, filter } = require('lodash/collection'),
    ga = require('react-ga');

let LocationsAdmin = React.createClass({displayName: "LocationsAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder],

    getInitialState() {
        return {
            selectedLocation: null,
            isEditMode: false
        };
    },

    componentDidMount() {
        this.fetchLocation();
        ga.pageview('/locations-admin');
    },

    fetchLocation() {
        const self = this;
        InventoryStore.fetchLocation(function(locations) {
            self.setState({
                locations
            });
        });
    },

    _onDeleteLocation(location, onSuccess, onFailure) {
        const haveSingleLocation = get(filter(this.state.locations, location => location.enable), 'length') === 1;
        if (haveSingleLocation) {
            CustomDialog.showInfo(t('error'), t('location_admin_error_must_exist_one_location'));
        } else {
            CustomDialog.showWarningConfirmation(t('warning'),t('location_admin_warning_deleting_location_will_remove_all_related'), () => {
                InventoryStore.deleteLocation(location, onSuccess, onFailure);
            });
        }
    },

    _onChangeLocation(location, onSuccess, onFailure) {
        InventoryStore.changeLocation(location, onSuccess, onFailure);
    },

    _onAddLocation(location, onSuccess, onFailure) {
        InventoryStore.addLocation(location, onSuccess, onFailure);
    },

    _onRowSelection(
        location,
        itemIndex,
        lastRowScrollPosition,
        headerActiveFilters
    ) {
        this.setState(
            {
                selectedLocation: location,
                isEditMode: !!location,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset is outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onCancel() {
        this.setState({
            selectedLocation: null,
            isEditMode: false
        });
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    render() {
        if (!this.state.locations) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('location_admin_change_success'),
                changeFailureMessage: t('location_admin_change_failure'),
                deleteSuccessMessage: t('location_admin_delete_success'),
                addSuccessMessage: t('location_admin_add_success'),
                addFailureMessage: t('location_admin_failure_success')
            };
            let contextHolder = this.getContextHolderInstance();
            let { selectedLocation, locations, isEditMode } = this.state;
            const secuancialOrder = orderBy(locations, 'description');

            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "name", 
                    isRequired: true, 
                    name: t('location_admin_name'), 
                    value: selectedLocation, 
                    label: t('location_admin_name'), 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "address", 
                    isRequired: false, 
                    name: t('location_admin_address'), 
                    value: selectedLocation, 
                    label: t('location_admin_address'), 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                )
            ];

            return (
                React.createElement("div", {className: "location-items-view"}, 
                    React.createElement(AdminScaffolding, {
                        moduleName: "ADMIN_LOCATION", 
                        title: t('location_admin_title'), 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedLocation, 
                        fetchItems: this.fetchLocation, 
                        headerFields: formFieldsEl, 
                        onAdd: this._onAddLocation, 
                        onChange: this._onChangeLocation, 
                        onCancel: this._onCancel, 
                        onDelete: this._onDeleteLocation, 
                        addEnterKeyDown: this._addEnterKeyDown
                    }, 

                        React.createElement(AdminScaffoldingTable, {
                            headerActiveFilters: this.state.headerActiveFilters, 
                            onRowSelection: this._onRowSelection, 
                            value: selectedLocation, 
                            filteredColumns: ['name'], 
                            sortByColumn: ['name'], 
                            columnNames: [
                              t('location_admin_column_name'),
                              t('location_admin_column_address')
                            ], 
                            displayAttributes: ['name', 'address']
                        }, 
                            secuancialOrder
                        )
                    )
                )
            );
        }
    }
});

module.exports = LocationsAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/LocationsAdmin/LocationsAdmin.js
 **/